module.exports = __webpack_public_path__ + "img/how-gloveler-works.e091daf6.jpg";